module.exports = __webpack_public_path__ + "img/training_room-left_bottom.8af5552c.jpg";